import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["category", "cover"];

  connect() {
    this.updateAssociatedCategories()
    this.element.addEventListener('click', this.stop.bind(this));
  }

  toggleDeductible(event) {
    const price170 = document.querySelectorAll('.price170')
    const price290 = document.querySelectorAll('.price290')
    if (event.params.deductible === 170) {
      price290.forEach((el) => {
        el.classList.add('d-none')
      })
      price170.forEach((el) => {
        el.classList.remove('d-none')
      })
    }

    if (event.params.deductible === 290) {
      price170.forEach((el) => {
        el.classList.add('d-none')
      })
      price290.forEach((el) => {
        el.classList.remove('d-none')
      })
    }
  }

  updateAssociatedSwitches(event) {
    const covers = this.coverTargets.filter(cover => cover.classList.contains(event.params['category']))

    covers.forEach((cover) => {
      if (event.srcElement.checked == true) {
        cover.checked = true
      } else {
        cover.checked = false
      }
    })
    covers[covers.length - 1].dispatchEvent(new Event('input', { 'bubbles': true }));
  }

  updateAssociatedCategories() {
    const categories = this.categoryTargets

    categories.forEach((category) => {
      const covers = this.coverTargets.filter(cover => cover.classList.contains(category.id))
      const allCoversChecked = covers.every(cover => cover.checked);
      if (allCoversChecked) {
        category.checked = true;
      }
    })
  }

  stop(event) {
    event.stopPropagation();
  }
}
